/* eslint-disable radix */
/* eslint-disable consistent-return */
import { action, computed, observable } from 'mobx';
import { purchaseStatusPopupState } from 'Components/common/purchaseStatusPopup';
import { toasterState } from 'Components/common/toaster';
import { loginValidate } from 'Utils/commonApi';
import { makeApi, URLS } from 'Utils/apiUtil';
import { Utils } from 'Utils/utils';
import { salesgearUserObj, userDetail } from './userDetail';
import { monthNames } from '../utils/constants';

class Profile {
  @observable currentPasswordError = false;

  @observable isLoading = false;

  @observable savedCardData = '';

  @observable planDetails = {};

  @observable teamMembers = [];

  @observable teamDetails = {};

  @observable usageAnalyticsData = { data: [] };

  @observable APIUsageAnalyticsData = { search: [], purchase: [], enrich: [] };

  @observable apiUsageLoading = false;

  @observable isGetTeamMemberLoading = false;

  @observable teamMemberApiLoading = false;

  @observable moreCreditsPlanDetails = [];

  @observable isMoreCreditsPlanLoading = false;

  @computed
  get apiUsedForChart() {
    const thisObj = this;
    const apiUsed = [];
    if (userDetail.userInfo.memberSubscription.apiSearchCredits > 0)
      apiUsed.push({ key: 'search', title: 'Prospect API - Search Contacts' });

    if (userDetail.userInfo.memberSubscription.apiPurchaseCredits > 0)
      apiUsed.push({
        key: 'purchase',
        title: 'Prospect API - Purchase Contacts',
      });

    if (userDetail.userInfo.memberSubscription.apiEnrichCredits > 0)
      apiUsed.push({ key: 'enrich', title: 'Enrich API' });

    return apiUsed;
  }

  @action
  setLoading(value) {
    this.isLoading = value;
  }

  updateName = async payload => {
    const config = {
      url: URLS.updateProfileData,
      method: 'POST',
      data: payload,
    };
    this.setLoading(true);
    makeApi(config)
      .then(async response => {
        if (response && response.data === true) {
          await loginValidate(false);

          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Name has been updated successfully',
          );
        } else {
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Something went wrong. Plese try again later',
          );
        }
        this.setLoading(false);
      })
      .catch(error => {
        this.setLoading(false);
        console.log('User Profile Data error ', error);
      });
  };

  updateTimeZone = timezone => {
    const lastParenthesis = timezone.lastIndexOf(')') + 1;
    const firstParenthesis = timezone.lastIndexOf('(');
    const zoneValue = timezone.slice(firstParenthesis, lastParenthesis);
    const zoneName = timezone.split(zoneValue).pop();
    const config = {
      url: URLS.updateMemberTimeZone ? URLS.updateMemberTimeZone : '',
      method: 'POST',
      data: {
        zone_name: zoneName.trim(),
        zone_value: zoneValue,
      },
    };
    this.setLoading(true);
    makeApi(config)
      .then(async response => {
        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data
        ) {
          await loginValidate(false);
          this.setLoading(false);
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Timezone has been updated successfully',
          );
        } else {
          this.setLoading(false);
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Something went wrong. Plese try again later',
          );
        }
      })
      .catch(error => {
        this.setLoading(false);
        console.log('User Profile Data error ', error);
      });
  };

  updatePassword = (values, callBack) => {
    const { memberId } = userDetail.userInfo;
    const { newPassword, currentPassword } = values;
    const config = {
      url: URLS.updatePassword ? URLS.updatePassword : '',
      method: 'POST',
      params: {
        memberId: memberId || '',
        currentPassword,
        newPassword,
      },
    };
    makeApi(config)
      .then(response => {
        if (response && response.status && response.status === 200) {
          loginValidate(false);
          callBack();
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Password has been updated successfully',
          );
        } else {
          callBack();
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            'Something went wrong. Plese try again later',
          );
        }
      })
      .catch(error => {
        console.log('User Profile Data error ', error);
      });
  };

  checkCurrentPassword = value => {
    const config = {
      url: URLS.checkCurrentPassword ? URLS.checkCurrentPassword : '',
      method: 'POST',
      params: { userPassword: value },
    };
    makeApi(config)
      .then(response => {
        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data
        )
          this.currentPasswordError = false;
        else this.currentPasswordError = true;

        return false;
      })
      .catch(error => {
        console.log('Check Current Password error ', error);
      });
  };

  getTheRecurringEmails = async () => {
    this.setLoading(true);
    const config = {
      url: URLS?.userAnalytics?.emailReportForRecurring,
      method: 'GET',
    };
    const response = await makeApi(config);
    this.setLoading(false);
    return response;
  };

  getRecurringDataById = async key => {
    this.setLoading(true);
    try {
      const targetURL = Utils.generateUrl(
        URLS?.userAnalytics?.deleteRecurringMails,
        { mailId: key },
      );

      const config = {
        url: targetURL,
        method: 'GET',
      };
      const res = await makeApi(config);
      this.setLoading(false);
      return res;
    } catch (e) {
      this.setLoading(false);
      console.log('get recurring email by id failed', e);
    }
  };

  createRecurringEmail = async appData => {
    try {
      this.setLoading(true);
      const config = {
        url: URLS?.userAnalytics?.emailReportForRecurring,
        method: 'POST',
        data: appData,
      };
      const res = await makeApi(config);
      this.setLoading(false);
      return res;
    } catch (e) {
      console.log('create recurring email failed', e);
      this.setLoading(false);
    }
  };

  updateRecurringEmail = async appData => {
    try {
      this.setLoading(true);
      const config = {
        url: URLS?.userAnalytics?.emailReportForRecurring,
        method: 'PUT',
        data: appData,
      };
      const res = await makeApi(config);
      this.setLoading(false);
      return res;
    } catch (e) {
      console.log('Update recurring email failed', e);
      this.setLoading(false);
    }
  };

  deleteRecurringMail = async key => {
    this.setLoading(true);
    try {
      const targetURL = Utils.generateUrl(
        URLS?.userAnalytics?.deleteRecurringMails,
        { mailId: key },
      );

      const config = {
        url: targetURL,
        method: 'DELETE',
      };
      const res = await makeApi(config);
      this.setLoading(false);
      return res;
    } catch (e) {
      this.setLoading(false);
      console.log('delete recurring email schedule failed', e);
    }
  };

  connectToSalesgear = async apiKey => {
    let isSuccess = false;
    try {
      this.setLoading(true);
      const config = {
        url: URLS?.salesgear?.authenticate,
        method: 'POST',
        data: { apiKey },
      };
      const res = await makeApi(config);
      if (res?.data) {
        userDetail.setUserInfo({
          ...userDetail.userInfo,
          salesgearApiKey: apiKey,
        });
        userDetail.setSalesgearUserInfo(res.data);
        toasterState.setToastMsg(
          'Successfully connected to Salesgear',
          'success',
        );
        isSuccess = true;
      } else {
        toasterState.setToastMsg(
          'Unable to valid user account - please check your APIKEY.',
          'failure',
        );
        isSuccess = false;
      }

      this.setLoading(false);
      return isSuccess;
    } catch (e) {
      console.log('Connect with salesgear Apikey failed', e);
      this.setLoading(false);
      return isSuccess;
    }
  };

  deleteSalesgearAPIKey = async () => {
    let isSuccess = false;
    try {
      const config = {
        url: URLS?.salesgear?.authenticate,
        method: 'DELETE',
      };
      const res = await makeApi(config);
      if (res?.data) {
        toasterState.setToastMsg('Disconnected successfully', 'success');
        userDetail.setSalesgearUserInfo(salesgearUserObj);
        userDetail.setUserInfo({
          ...userDetail.userInfo,
          salesgearApiKey: '',
        });
        isSuccess = true;
      } else {
        toasterState.setToastMsg('Disconnect failed', 'failure');
        isSuccess = false;
      }
      return isSuccess;
    } catch (e) {
      console.log('delete salesgear api key failed', e);
      return isSuccess;
    }
  };

  @action
  getSavedCard = async () => {
    const config = {
      url: URLS.getSavedCard ? URLS.getSavedCard : '',
      method: 'POST',
    };
    const response = await makeApi(config);

    if (response && response.status && response.status === 200 && response.data)
      this.savedCardData = response.data;
  };

  getSubscriptionPlans = async () => {
    const config = {
      url: URLS.getSubscriptionPlans ? URLS.getSubscriptionPlans : '',
      method: 'GET',
    };
    const response = await makeApi(config);
    if (response && response.status && response.status === 200 && response.data)
      this.planDetails = response.data;
  };

  fetchTeamMembers = async () => {
    const config = {
      url: URLS.getTeamDetails ? URLS.getTeamDetails : '',
      method: 'GET',
    };
    const response = await makeApi(config);
    return response;
  };

  getTeamDetails = async (data = { loader: true }) => {
    const { loader } = data;
    if (loader) this.isGetTeamMemberLoading = true;
    const response = await this.fetchTeamMembers();
    if (response && response.status && response.status === 200)
      if (
        response.data &&
        response.data.members &&
        response.data.members.length
      )
        this.teamMembers = response.data.members
          .filter(
            member =>
              member.status !== 'INACTIVE' && member.status !== 'INVITED',
          )
          .sort((member1, member2) => {
            return (
              member2.lbCreditsUsedInBillingCycle -
              member1.lbCreditsUsedInBillingCycle
            );
          })
          .concat(
            response.data.members.filter(member => member.status === 'INVITED'),
            response.data.members
              .filter(member => member.status === 'INACTIVE')
              .sort((member1, member2) => {
                return (
                  member1.lbCreditsUsedInBillingCycle -
                  member2.lbCreditsUsedInBillingCycle
                );
              }),
          );
    this.teamDetails = response.data?.teamDetails;
    if (loader) this.isGetTeamMemberLoading = false;
  };

  addUser = async values => {
    this.teamMemberApiLoading = true;
    const postData = {};
    postData.email = values.email ? values.email : '';
    postData.firstName = values.firstName ? values.firstName : '';
    postData.lastName = values.lastName ? values.lastName : '';
    postData.lbCreditLimit =
      values.credits !== -1 && values.credits !== null
        ? // eslint-disable-next-line radix
          parseInt(values.credits)
        : -1;
    postData.status = 'ACTIVE';
    const config = {
      url: URLS.teamInvite ? URLS.teamInvite : '',
      method: 'POST',
      data: postData,
    };
    const response = await makeApi(config);
    this.teamMemberApiLoading = false;
    if (response && response.data && response.data.code) {
      const responseCode = response.data.code;
      let msgStr = '';
      if (responseCode === 200) {
        loginValidate(false);
        this.getTeamDetails({ loader: false });
        msgStr = `We have sent an Invitation email to ${values.email}`;
      } else if (responseCode === 1013) {
        msgStr = 'This user is already part of your team plan';
      } else if (responseCode === 1014) {
        msgStr = 'Email is already associated with another enterprise.';
      } else if (responseCode === 1015) {
        msgStr =
          'You have used all the seats available in your current plan. To add more users, please contact sales.';
      } else if (responseCode === 1012) {
        msgStr = 'Sorry, something went wrong. Please try again';
      } else if (responseCode === 1016) {
        msgStr = 'Invalid credit limit';
      }
      if (msgStr !== '')
        purchaseStatusPopupState.setToastMsg(
          null,
          null,
          null,
          null,
          null,
          msgStr,
        );
    } else if (
      response.response &&
      response.response.status &&
      response.response.status === 500
    ) {
      purchaseStatusPopupState.setToastMsg(
        null,
        null,
        null,
        null,
        null,
        'Sorry, something went wrong. Please try again or Contact <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>',
      );
    }
  };

  editUser = async data => {
    this.teamMemberApiLoading = true;
    const config = {
      url: URLS.editTeamMember,
      method: 'POST',
      data: {
        // eslint-disable-next-line radix
        lbCreditLimit: data.credits ? parseInt(data.credits) : -1,
        email: data.email,
      },
    };
    const response = await makeApi(config);
    this.teamMemberApiLoading = false;
    if (response.data.code === 200) {
      if (data.memberId === userDetail.userInfo.memberId) loginValidate(false);
      toasterState.setToastMsg(
        'Credit limit data updated successfully',
        'success',
      );
      this.getTeamDetails({ loader: false });
    } else {
      toasterState.setToastMsg(
        'Setting credit limit failed, please try again',
        'failure',
      );
    }
  };

  removeUser = ({ memberId, email }) => {
    this.teamMemberApiLoading = true;
    const config = {
      url: URLS.removeUser ? URLS.removeUser : '',
      method: 'POST',
      data: { memberId },
    };
    makeApi(config)
      .then(response => {
        if (
          response &&
          response.status &&
          response.status === 200 &&
          response.data &&
          response.data.code &&
          response.data.code === 200
        ) {
          loginValidate(false);
          this.getTeamDetails({ loader: false });
          purchaseStatusPopupState.setToastMsg(
            null,
            null,
            null,
            null,
            null,
            `Removed the user ${email} from the team!`,
          );
        }
        this.teamMemberApiLoading = false;
      })
      .catch(error => {
        this.teamMemberApiLoading = false;
        console.log('Get Team Details Error ', error);
      });
  };

  getBuyMoreCreditsPlans = async (data = { loader: true }) => {
    const { loader } = data;
    if (loader) this.isMoreCreditsPlanLoading = true;
    const subscriptionId = Utils.getActiveSubscriptioId();
    if (subscriptionId) {
      const config = {
        url: Utils.generateUrl(URLS.getActiveMoreCreditsPlans, {
          activeSubscriptionId: subscriptionId,
        }),
        method: 'GET',
      };
      const response = await makeApi(config);
      if (
        response &&
        response.status &&
        response.status === 200 &&
        response.data
      )
        this.moreCreditsPlanDetails = response.data;
    }
    if (loader) this.isMoreCreditsPlanLoading = false;
  };

  getParsedMonthRange = range => {
    return {
      startMonth: monthNames.indexOf(range.startMonth) + 1,
      startYear: parseInt(range.startYear),
      endMonth: monthNames.indexOf(range.endMonth) + 1,
      endYear: parseInt(range.endYear),
    };
  };

  getUsageAnalyticsData = async data => {
    const config = {
      url: URLS.getUsageAnalytics,
      method: 'POST',
      data: this.getParsedMonthRange(data),
    };
    const response = await makeApi(config);
    this.usageAnalyticsData = response.data || { data: [] };
  };

  getLineChartData = data => {
    const { chartData, rangeData, rangeLength, defaultValue } = data;
    const range = rangeData.map(value => {
      const [monthString, yearString] = value.split(' ');
      return {
        month: monthNames.indexOf(monthString) + 1,
        year: parseInt(yearString),
      };
    });

    return Array.from({ length: rangeLength }).map((item, index) => {
      return (
        chartData.find(monthData => {
          return (
            monthData.month === range[index].month &&
            monthData.year === range[index].year
          );
        })?.credits || defaultValue
      );
    });
  };

  getTeamMemberAnalyticsData = (rangeData, rangeLength) => {
    return this.getLineChartData({
      rangeData,
      rangeLength,
      chartData: this.usageAnalyticsData.data,
      defaultValue: 0,
    });
  };

  getAdminOverallAnalyticsData = (rangeData, rangeLength) => {
    return this.getLineChartData({
      rangeData,
      rangeLength,
      chartData: this.usageAnalyticsData.data.filter(data => {
        return data?.memberId === null;
      }),
      defaultValue: 0,
    });
  };

  getTeamBarChartData = data => {
    const { rangeData, rangeLength, barChartColors, memberData } = data;
    return memberData.map((member, index) => {
      return {
        label:
          !member.firstName && !member.lastName
            ? member.emailId
            : `${member.firstName || ''} ${member.lastName || ''}`,
        data: this.getLineChartData({
          rangeData,
          rangeLength,
          chartData: this.usageAnalyticsData.data.filter(monthData => {
            return monthData?.memberId === member.memberId;
          }),
          defaultValue: null,
        }),
        backgroundColor: barChartColors[index],
      };
    });
  };

  getAPIUsageAnalytics = async (data, key) => {
    const { startDate, endDate, frequency } = data;
    const endDateForCondition = new Date(endDate);
    const adjustedEndDate = new Date(
      endDateForCondition.getFullYear(),
      endDateForCondition.getMonth(),
      endDateForCondition.getDate(),
      23,
      59,
      59,
    );

    const startDateForCondition = new Date(startDate);
    const adjustedStartDate = new Date(
      startDateForCondition.getFullYear(),
      startDateForCondition.getMonth(),
      startDateForCondition.getDate(),
      0,
      0,
      0,
    );

    this.apiUsageLoading = true;
    const config = {
      url: URLS.apiUsageAnalytics,
      method: 'POST',
      data: {
        frequency,
        endDate: Number(adjustedEndDate),
        startDate: Number(adjustedStartDate),
      },
    };
    const response = await makeApi(config);

    const { data: apiData = [], ...remainingProps } = response?.data || {};

    if (key)
      this.APIUsageAnalyticsData = {
        ...this.APIUsageAnalyticsData,
        [key]: apiData,
        ...remainingProps,
      };
    else
      this.APIUsageAnalyticsData = {
        search: apiData,
        purchase: apiData,
        enrich: apiData,
        ...remainingProps,
      };

    this.apiUsageLoading = false;
  };
}

const profileState = new Profile();

export default profileState;
